import { MutationHookOptions, useMutation } from "@apollo/client";
import setDefaultShippingAddressGql from "@whoppah/apollo/mutation/setDefaultShippingAddress.graphql";
import {
  SetDefaultShippingAddressMutation,
  SetDefaultShippingAddressMutationVariables,
} from "@whoppah/apollo/schema";

/**
 * WHO-5532. Makes one of the merchant's own addresses the default delivery
 * address. The mutation returns the `Merchant` with both role pointers, so
 * the normalized cache patches every `me.merchants[0]` reader on its own.
 */
const useSetDefaultShippingAddress = (
  options?: MutationHookOptions<
    SetDefaultShippingAddressMutation,
    SetDefaultShippingAddressMutationVariables
  >
) => {
  return useMutation(setDefaultShippingAddressGql, options);
};

export default useSetDefaultShippingAddress;
